import {constants} from "../../../constants";

export default class ClosePaytable {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.web.closePaytable();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.EDIG:
                event["closeHTML"] = this._default;
                break;
            default:
                event["closePaytable"] = this._default
        }

        return event;
    }
}
